import { HttpErrorResponse } from "@angular/common/http";

import { AccountWithContraAccount } from "@models/account-with-contra-account.model";
import { Configuration } from "@models/configuration.model";
import { Disbursement } from "@models/disbursement.model";
import { FundIncludingLatestNavValue } from "@models/fund-including-latest-nav-value.model";
import { GfhTransaction } from "@models/gfh-transaction.model";
import { createReducer, on } from "@ngrx/store";

import {
  ACCOUNTS_ACTION_FAILURE,
  CLEAR_ACCOUNT_DATA,
  SET_ACCOUNT_CONFIGURATION,
  SET_ACCOUNTS_FOR_CLIENT,
  SET_ACCOUNTS_LOADING,
  SET_DISBURSEMENTS_FOR_ACCOUNT,
  SET_FUNDS,
  SET_GFH_TRANSACTIONS_FOR_ACCOUNT,
} from "./accounts.actions";

export interface AccountState {
  accountsLoading: boolean;
  accounts: AccountWithContraAccount[];
  groupedGfhTransactions: GfhTransaction[];
  funds: FundIncludingLatestNavValue[];
  error: HttpErrorResponse | null;
  accountConfiguration: Configuration;
  disbursements: Disbursement[];
}

const initialState: AccountState = {
  accountsLoading: false,
  accounts: [],
  groupedGfhTransactions: [],
  funds: [],
  error: null,
  accountConfiguration: new Configuration(),
  disbursements: [],
};

export const ACCOUNTS_REDUCER = createReducer(
  initialState,
  on(ACCOUNTS_ACTION_FAILURE, (state, action): AccountState => {
    return {
      ...state,
      error: action.error,
    };
  }),
  on(
    SET_ACCOUNTS_LOADING,
    (state: AccountState, action: { loading: boolean }): AccountState => {
      return {
        ...state,
        accountsLoading: action.loading,
      };
    }
  ),

  on(
    SET_ACCOUNTS_FOR_CLIENT,
    (
      state: AccountState,
      action: { data: AccountWithContraAccount[] }
    ): AccountState => {
      return {
        ...state,
        accounts: action.data,
      };
    }
  ),

  on(
    SET_GFH_TRANSACTIONS_FOR_ACCOUNT,
    (
      state: AccountState,
      action: { groupedGfhTransactions: GfhTransaction[] }
    ): AccountState => {
      return {
        ...state,
        groupedGfhTransactions: action.groupedGfhTransactions,
      };
    }
  ),

  on(
    SET_FUNDS,
    (
      state: AccountState,
      action: { funds: FundIncludingLatestNavValue[] }
    ): AccountState => {
      return {
        ...state,
        funds: action.funds,
      };
    }
  ),

  on(
    SET_ACCOUNT_CONFIGURATION,
    (
      state: AccountState,
      action: {
        configuration: Configuration;
      }
    ): AccountState => {
      return {
        ...state,
        accountConfiguration: action.configuration,
      };
    }
  ),

  on(CLEAR_ACCOUNT_DATA, (state): AccountState => {
    return {
      ...state,
      accounts: [],
      groupedGfhTransactions: [],
      funds: [],
      disbursements: [],
    };
  }),

  on(
    SET_DISBURSEMENTS_FOR_ACCOUNT,
    (
      state: AccountState,
      action: { disbursements: Disbursement[] }
    ): AccountState => {
      return {
        ...state,
        disbursements: action.disbursements,
      };
    }
  )
);
